import { call, cancel, cancelled, fork, put, race, select, take } from 'redux-saga/effects';

import * as SampleConstants from '../constants';
import * as D from '../deps';

export function* playSampleWorker(url) {
  let provider;
  if (!url) {
    throw new Error('playSampleWorker: expected url');
  }
  const audioSrc = {
    url,
    format: SampleConstants.SAMPLE_ENCODING,
    audioType: D.AudioConstants.AudioTypes.SAMPLE,
  };
  try {
    // TODO: move into a less connected pattern, shouldn't be calling AudioPlayer directly
    provider = yield call(D.AudioWorkers.playSource, audioSrc, 0);

    const result = yield race({
      stop: take(D.Constants.Samples.SamplePlayerActions.STOPPED),
      ended: take(D.Constants.Samples.SamplePlayerActions.ENDED),
    });
    if (result.stop) {
      yield call(provider.pause);
    }
  } finally {
    if (yield cancelled()) {
      if (provider) {
        yield call(provider.pause);
      }
    }
  }
}

export function* playSingleSample(action) {
  const { url, resumeTrackOnEnd } = action.data;
  try {
    yield call(playSampleWorker, url);
    if (resumeTrackOnEnd) {
      yield put(D.Actions.Playback.intentPlayTrack());
    }
  } finally {
    if (yield cancelled()) {
      yield put({
        type: D.Constants.Samples.SamplePlayerActions.STOPPED,
      });
    }
  }
}

export function* playSeveralSamples(samples) {
  let url;
  const newSamples = samples;
  const shouldResumeOnEnd = yield select(D.AudioUtils.isAudioPlayerPlaying);
  try {
    while (newSamples.length) {
      url = newSamples.shift().url;
      yield call(playSampleWorker, url);
    }
  } finally {
    if (shouldResumeOnEnd) {
      yield put(D.Actions.Playback.intentPlayTrack());
    }
  }
}

export function* handlePlaySamples(action) {
  const samplesPlayFork = yield fork(playSeveralSamples, action.data.samples);
  const result = yield race({
    playSamples: samplesPlayFork.toPromise(),
    playTrack: take(D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK),
    stopSamples: take(D.Constants.Samples.SamplePlayerActions.STOP_SAMPLES),
  });
  if (!result.playSamples) {
    yield cancel(samplesPlayFork);
  }
}
